import ManageInbox from './component'
import { connect } from 'react-redux'
import { compose, lifecycle,  } from 'recompose'
import * as InboxSelectors from 'app/modules/inbox/selectors'
import { fetchInboxList, patchInbox, createInbox, archiveInbox } from 'app/modules/inbox/actions'
import { fetchEmbed } from 'app/modules/embed/actions'

import * as EmbedSelectors from 'app/modules/embed/selectors'
import { bindActionCreators } from 'redux'




const mapStateToProps = (state, props) => ({
  embed: EmbedSelectors.getEmbedConfig(state),
  inbox: props.params.inboxId !== 'new' && InboxSelectors.inbox(props.params.inboxId)(state),
  createdInboxId: InboxSelectors.createdInboxId(state),
  inboxesById: InboxSelectors.inboxes(state).toJS()
})


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchInboxList,
      patchInbox,
      createInbox,
      fetchEmbed,
      archiveInbox
    },
    dispatch
  ),
})



export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle({
      componentDidMount() {
        this.props.actions.fetchInboxList()
        this.props.actions.fetchEmbed()
      }
    })
)(ManageInbox)




// WEBPACK FOOTER //
// ./src/scripts/components/settings/inboxes/ManageInbox/index.js